import { useStockPrice } from "../context/stockPrice/StockPriceContext";
import { useRuntimeConstants } from "../context/runtimeConstants/RuntimeConstantsContext";
import { getFeature } from "../utils/features";
import { useIsInStockContext } from "../context/isInStock/IsInStockContext";

export default function useSingleProductData(ratings) {
  const { products } = useStockPrice();
  const { product, getTranslation } = useRuntimeConstants();
  const { isInStock } = useIsInStockContext();

  const isSizingScaleEnabled = getFeature("pdp_sizing_scale_test").isEnabled();

  const subRatings = ratings?.subRatings ?? [];

  const topSubRating = subRatings.filter((rating) =>
    ["fit", "size"].includes(rating.id?.toLowerCase())
  );

  const labeledSubRatings = topSubRating.map((rating) => ({
    ...rating,
    midLabel: getTranslation("pdp_ratings_reviews_slider_size_selected_label"),
  }));

  const showSizingScale =
    isSizingScaleEnabled && isInStock && labeledSubRatings.length > 0;

  return {
    product,
    mainProducts: products ? [products] : [],
    isSizingScaleEnabled,
    labeledSubRatings,
    showSizingScale,
  };
}
